import React from 'react';
import { Loader } from 'ui';
import Background from '../Background';
import styles from './PageLoader.module.css';

const PageLoader = () => (
    <Background wrapper={styles.wrapper} className={styles.card}>
        <Loader />
    </Background>
);

export default PageLoader;
